module.exports = __webpack_public_path__ + "img/close.162602bc.png";